/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

// Data
import data from "layouts/dividendosEProventos/components/DividendosTable/data";
import { getAssetProvents } from "layouts/dividendosEProventos/api/proventsApi";

function DividendosTable() {
  const [provents, setProvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { columns, rows } = data(provents);

  useEffect(() => {
    loadProvents();
  }, []);

  const loadProvents = async () => {
    setIsLoading(true);
    setErrorMessage(null);

    try {
      const response = await getAssetProvents();
      setProvents(response?.results ?? []);
    } catch (error) {
      setErrorMessage("Nao foi possivel carregar seus proventos.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" fontWeight="medium">
            Dividendos e proventos
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{
                fontWeight: "bold",
                color: ({ palette: { success } }) => success.main,
                mt: -0.5,
              }}
            >
              done
            </Icon>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;Valores calculados pela sua quantidade atual em carteira
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <MDBox>
        {isLoading ? (
          <MDBox display="flex" justifyContent="center" py={4}>
            <CircularProgress color="inherit" size={24} />
          </MDBox>
        ) : errorMessage ? (
          <MDBox px={3} pb={3}>
            <MDTypography variant="button" color="error" fontWeight="regular">
              {errorMessage}
            </MDTypography>
          </MDBox>
        ) : rows.length > 0 ? (
          <DataTable
            table={{ columns, rows }}
            showTotalEntries={false}
            isSorted={false}
            noEndBorder
            entriesPerPage={false}
          />
        ) : (
          <MDBox px={3} pb={3}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Nenhum provento encontrado para os ativos da sua posicao atual.
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </Card>
  );
}

export default DividendosTable;
